<app-menu #actionsMenu [items]="menuItems" [attr.step-id]="'project-actions-menu'">
    <i class="pi pi-ellipsis-v icon-xs p-0 m-0 cursor-pointer" (click)="showActionsMenu($event)"></i>
</app-menu>